import { createApp } from "vue";
import { createPinia } from "pinia";
import { createSentryPiniaPlugin } from "@sentry/vue";

import App from "./App.vue";
import router from "./router";
import { i18n } from "@/i18n";

import "./main.css";

import "@polargold/luv-ui-library/dist/luv-ui-library.css";
import "@polargold/luv-ui-library/dist/assets/fonts/fonts.css";

import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import "@fortawesome/fontawesome-free/css/brands.min.css";
import { useAppLanguageStore } from "@/stores/appLanguageStore";
import { initializeSentry } from "@/utils/InitializeSentry";

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(i18n);

// Instantiate before mount so the persisted language is applied to i18n from the first render.
useAppLanguageStore();

initializeSentry(app, router);
pinia.use(createSentryPiniaPlugin());

app.mount("#app");
